import Forum from "messaging/forums/forum";
import Message from "messaging/message";
import { validateMessage } from "messaging/_api/messaging-validation";

type BulkMessageRequest = {
  id?: string;  
  forum?: Forum;
  subject: string;
  contentPlainText?: string;
  markCreated: boolean;
  markDeleted: boolean;
  markRead: boolean;
  markUnread: boolean;
  publish?: boolean;
}

export default class BulkMessageAPIRequest {
  public payload: Array<BulkMessageRequest>;

  public constructor(messages: Message[]) {
    if (messages.length === 0) throw new Error("At least one message is required.");
    for (const message of messages) {
      const errors = validateMessage(message, { requireForumId: false });
      if (Object.keys(errors).length > 0) throw new Error(Object.values(errors)[0]);
    }
    this.payload = [];
    
    for (const message of messages) {
      this.payload.push({
        id: message.id?.value,
        forum: new Forum(message.forum),
        subject: message.subject ?? "",
        contentPlainText: message.content,
        markCreated: message.isMarkedForCreation ?? false,
        markDeleted: message.isMarkedForDeletion ?? false,
        markRead: message.isMarkedRead ?? false,
        markUnread: message.isMarkedUnread ?? false,
        // Explicit publish intent so the backend can tell publish (true) from retract (false) from an
        // untouched edit (undefined = leave the published state as-is). A new comment defaults to an
        // unpublished draft; publishing is a separate, deliberate action.
        publish: message.isMarkedForPublish
          ? true
          : message.isMarkedForUnpublish
            ? false
            : message.isMarkedForCreation
              ? false
              : undefined,
      });
    }
  }
}
